import Colors from '../../../../styles/colors';

const styles = theme => ({
    wrapper: {
        minHeight: 24,
        borderRadius: 18,
        display: 'inline-flex',
        width: 'max-content',
    },
    text: {
        fontSize: 16,
        fontFamily: theme.typography.h1.fontFamily,
        paddingLeft: 15,
        paddingRight: 15,
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
            lineHeight: '30px',
        },
    },
    difficulty3: {
        backgroundColor: `rgba(${Colors.blueRGB}, .5)`,
    },
    difficulty2: {
        backgroundColor: `rgba(${Colors.yellowRGB}, .5)`,
    },
    difficulty1: {
        backgroundColor: `rgba(${Colors.redRGB}, .2)`,
        '& span': {
            color: Colors.red,
        },
    },
});

export default styles;
